const theme = {
  silly: 'rainbow',
  input: 'grey',
  prompt: 'grey',
  data: 'grey',
  verbose: 'white',
  info: 'white',
  code: 'cyan',
  help: 'green',
  warn: 'yellow',
  error: 'red',
  success: 'green'
};

export default theme;
